import { icons } from "../../assets/icons/icons";

export const colors_button = {
  primary: "#FCAF17",
  success: "#0F9F0C",
  white: "#ffffff",
  black: "#000000",
  text: "#4A4A4A",
  sky: "#2186E3",
  red: "#E80000",
  sub_primary: "#F79009",
  add_request: "#000000",
  pdf: "#DD2E2E",
  word: "#0067C7",
};

export type modeType = {
  add: "add";
  del: "del";
  next: "next";
  password: "password";
  success: "success";
  send: "send";
  cancel: "cancel";
  change_advisor: "change_advisor";
  history_request: "history_request";
  send_request: "send_request";
  done: "done";
  transfer: "transfer";
  add_request: "add_request";
  save: "save";
  word: "word";
  pdf: "pdf";
  excel: "excel";
};
export const calculateIconMode = (
  mode: string | undefined
): string | undefined => {
  switch (mode) {
    case "add":
      return icons.add;
    case "password":
      return icons.password;
    case "next":
      return icons.arrowSquareRight;
    case "send":
      return icons.send_2;
    case "save":
      return icons.documentText;
    case "cancel":
      return icons.close_square;
    case "change_advisor":
      return icons.sms_tracking;
    case "history_request":
      return icons.video_time_white;
    case "send_request":
      return icons.sms_edit;
    case "done":
      return icons.tick_square;
    case "transfer":
      return icons.recovery_convert;
    case "add_request":
      return icons.add_square;
    case "excel":
      return icons.excelIcon;
    case "pdf":
      return icons.pdfIcon;
    case "word":
      return icons.wordIcon;
    default:
      return undefined;
  }
};
export const calculateBackgroundMode = (
  mode: string | undefined
): string | undefined => {
  switch (mode) {
    case "add":
      return colors_button.success;
    case "next":
      return colors_button.success;
    case "del":
      return colors_button.red;
    case "success":
      return colors_button.success;
    case "password":
      return colors_button.sub_primary;
    case "send":
      return colors_button.success;
    case "cancel":
      return colors_button.red;
    case "change_advisor":
      return colors_button.primary;
    case "history_request":
      return colors_button.sky;
    case "send_request":
      return colors_button.success;
    case "done":
      return colors_button.success;
    case "transfer":
      return colors_button.sub_primary;
    case "add_request":
      return colors_button.white;
    case "save":
      return colors_button.sky;
    case "pdf":
      return colors_button.pdf;
    case "word":
      return colors_button.word;
    case "excel":
      return colors_button.success;
    default:
      return colors_button.primary;
  }
};
